export const UserStatus = {
  INACTIVE: { id: 0, code: 'inactive' },
  ACTIVE: { id: 1, code: 'active' },
  PENDING: { id: 2, code: 'invited' },
};
